var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupsClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.94455 0 0 4.94455 0 11C0 17.0554 4.94455 22 11 22C17.0554 22 22 17.0554 22 11C22 4.94455 17.0554 0 11 0ZM11 1.30693C16.3366 1.30693 20.6931 5.66337 20.6931 11C20.6931 16.3366 16.3366 20.6931 11 20.6931C5.66337 20.6931 1.30693 16.3366 1.30693 11C1.30693 5.66337 5.66337 1.30693 11 1.30693ZM11 3.81188C10.6297 3.81188 10.3465 4.09505 10.3465 4.46535V9.8675C9.95446 10.0853 9.69307 10.5208 9.69307 11C9.69307 11.7188 10.2812 12.3069 11 12.3069C11.4792 12.3069 11.9147 12.0455 12.1325 11.6535H15.3564C15.7267 11.6535 16.0099 11.3703 16.0099 11C16.0099 10.6297 15.7267 10.3465 15.3564 10.3465H12.1325C12.0236 10.1505 11.8495 9.97641 11.6535 9.8675V4.46535C11.6535 4.09505 11.3703 3.81188 11 3.81188ZM9.91089 15.7921C9.54059 15.7921 9.25743 16.0752 9.25743 16.4455C9.25743 16.8158 9.54059 17.099 9.91089 17.099H12.0891C12.4594 17.099 12.7426 16.8158 12.7426 16.4455C12.7426 16.0752 12.4594 15.7921 12.0891 15.7921H9.91089Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsClock);
export default __webpack_public_path__ + "static/media/groups-clock.98b976e88efa7222ce169c769d9c1974.svg";
export { ForwardRef as ReactComponent };